import { Box, Button, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { sendMailInfo } from '../../fetching/fetchingSurvey';
import { useTranslation } from 'react-i18next';

export default function SurveyFinish(props) {

    const {t} = useTranslation()

    const [mail, setMail] = useState("");

    const sendMail = () => {
        sendMailInfo(props.userId, mail);
        props.setMailShared();
    }

    return(
        <Box sx={{m: 3}}>
            <Typography variant="h2">{t("surveyFinishText1")}</Typography>
            <br/>
            <Typography>
            {t("surveyFinishText2")}
            </Typography>
            <Box sx={{m: 2, display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "center"}}>
            {
                props.mailShared
                ? <Typography sx={{fontWeight: 500}}>{t("surveyFinishText3")}</Typography>
                :
                <>
                    <TextField placeholder={t("surveyFinishPlaceholder")} value={mail} onChange={e => setMail(e.target.value)}/>
                    <Button variant="contained" onClick={sendMail} sx={{ml: 2}}>{t("surveyFinishButton")}</Button>
                </>

            }

            </Box>
            <Typography>{t("surveyFinishText4", {mail: "bizis@th-owl.de"})}</Typography>

        </Box>
    )
}